import script from "./UserPgIchiran.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPgIchiran.vue?vue&type=script&setup=true&lang=js"

import "./UserPgIchiran.vue?vue&type=style&index=0&id=61b5f0e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b5f0e5"]])

export default __exports__